<template>
  <div class="sms">
    <GarminLogo />
    <g-heading
      :content="$t.programTitle"
      text-align="left"
      size="2"
      class="content__heading"
    >
      <h2> {{ $t.programTitle }}</h2>
    </g-heading>
    <g-spacer
      color="white"
      divider="true"
      height="32"
      class="hr__divider"
    />
    <component :is="componentName" />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import * as GHeading from '@garmin/components-global-web/dist-web/components/GHeading/';
import '@garmin/components-global-web/dist-web/components/GSpacer';
import { getComponent } from '../helpers/getSmsPageComponent';
import useSmsOptInStatusStore from '../store/smsOptInStatus';
import useUserActionsStore from '../store/userAction';
import useOriginalQueryStore from '../store/originalQuery';
import GarminLogo from '../components/GarminLogo.vue';

const smsOptInStatusStore = useSmsOptInStatusStore();
const userActionsStore = useUserActionsStore();
const originalQueryStore = useOriginalQueryStore();

const {
  smsOptInStatus,
  smsOptInServiceSuccess,
  isSmsStatusLoaded,
} = storeToRefs(smsOptInStatusStore);
const { userAction } = storeToRefs(userActionsStore);
const { originalQuery } = storeToRefs(originalQueryStore);

const componentName = computed(() => {
  const { status, source } = smsOptInStatus.value ?? {};
  return getComponent(
    status,
    userAction.value,
    isSmsStatusLoaded.value,
    smsOptInServiceSuccess.value,
    originalQuery.value,
    source,
  );
});
</script>
<style lang="scss">
.sms {
  display: flex;
  flex-direction: column;
  max-width: $breakpoint-sm;
  margin: 0 auto;
  padding: 0;

  .content__heading {
    h1 {
      margin: 0;
    }
  }
}
</style>
